<template>
  <div class="purchase-detail-page">
    <!-- Header Section - 头部信息展示 -->
    <div class="header-section">
      <div class="d-flex align-items-end">
        <div class="d-flex">
          <el-image
            :src="'/image/static/img/nopic.jpg'"
            :preview-src-list="['/image/static/img/nopic.jpg']"
            style="width: 134px; height: 88px"
            fit="cover"
          >
            <div slot="error">
              <img
                src="/image/static/img/nopic.jpg"
                style="width: 134px; height: 88px"
              />
            </div>
          </el-image>
        </div>
        <div style="flex: 1" class="ml-2">
          <h5 style="color: #101010">
            {{ baseInfo.purchaseDate || '--' }}
            &nbsp; 面料采购 &nbsp;
            {{ baseInfo.scmName || '--' }}
          </h5>
          <div class="d-flex justify-content-between">
            <div class="d-flex align-items-center">
              <div style="margin-bottom: 10px; height: 29px; line-height: 29px; overflow: hidden">
                <span style="font-size: 14px; color: #606266">
                  NO：{{
                    baseInfo.purchaseFabricNo ||
                    $l('tips_autoGenerate') ||
                    '自动生成'
                  }}
                </span>
                <el-divider direction="vertical" />
                <el-tag
                  size="mini"
                  :type="
                    baseInfo.purchaseStatus === 'Y'
                      ? 'success'
                      : baseInfo.purchaseStatus === 'N'
                      ? 'danger'
                      : 'warning'
                  "
                >
                  {{ baseInfo.v_purchaseStatus || 'New' }}
                </el-tag>
                <el-divider direction="vertical" />
                <span style="font-size: 14px; color: #606266">
                  {{ $l('form_label_update_time') || '最新更新' }}：{{
                    baseInfo.modifyByName || '--'
                  }}
                  at {{ baseInfo.modifyTime || '--' }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 详情表单和明细表格 -->
    <detail-form
      ref="detailForm"
      :purchaseFabricCode="params.code"
      :disabled="isDisableEditForm"
      :pageType="pageType"
      @loaded="onFormLoaded"
    />
  </div>
</template>

<script>
import DetailForm from './components/detail-form/index.vue'

export default {
  name: 'purchase-fabricPurchase-detail',
  components: {
    DetailForm,
  },
  data() {
    return {
      baseInfo: {},
    }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    // 是否禁用表单
    isDisableEditForm() {
      return this.pageType === 'detail'
    },
  },
  methods: {
    onFormLoaded(data) {
      this.baseInfo = data
    },
  },
}
</script>

<style lang="scss" scoped>
.purchase-detail-page {
  margin: -10px -10px 0;
  background: #f5f7fa;
  // min-height: calc(100% + 10px);

  .header-section {
    background: #fff;
    margin-bottom: 12px;
  }
}
</style>
